<template>
  <div class="atcclcont between">
    <div class="cont">
      <div class="header between">
        <div class="atccl_title flex_start">
          <div
            v-for="(item, index) in taglist"
            :key="index"
            :class="{ actitle: isactitle == index }"
            @click="clitag(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- <div class="atccmo">更多></div> -->
      </div>
      <div class="atcclist">
        <div
          class="atcclitem"
          v-for="(item, index) in articlist"
          :key="index"
          :class="{ bodernone: articlist.length - 1 == index }"
          @click="tojump(item)"
        >
          <div class="problem ellipsis">{{ item.title }}</div>
          <div class="answer">
            {{ item.content | toEllipsisFilter(130) }}
          </div>
          <div class="simple between">
            <div class="name center">
              <img src="../../../assets/claim/aaaa1_sample.png" alt="" /> XX律师
            </div>
            <div class="ritext flex_end">
              <div class="center">
                <img src="../../../assets/claim/time.png" class="time" />
                {{ item.updated_at || "2021-04-05" }}
              </div>
              <div class="center">
                <img src="../../../assets/base/kan.png" alt="num" />
                {{ item.view_num }}人看过
              </div>
            </div>
          </div>
        </div>
        <div class="pagination mt20">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="pageCount"
            :current-page="currentPage"
            :pager-count="5"
            @current-change="turnpage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="sideadv">
      <videolist class="vrk" :num="4" title="精选解答排行榜" />
      <articlelist
        class="arclerk"
        :list="a"
        @Inabatch="Inabatch"
        title="精选解答推荐"
      />
      <videolist2 class="vlrecom" :list="b" title="视频推荐" />
      <audiolist class="aork" :list="c" title="语音推荐" />
    </div>
  </div>
</template>

<script>
import videolist from "../../videoclaim/componens/videolist";
import videolist2 from "../../videoclaim/componens/videolist_2";
import articlelist from "../../videoclaim/componens/articlelist";
import audiolist from "../../videoclaim/componens/audiolist";
//Brother when you see this code, I have resigned, you resign, hurriedly resign, hurriedly resign, this company is a pit, all kinds of pits, what benefits are not, the construction period desperately pressure, overtime without overtime pay no vacation
export default {
  components: {
    videolist,
    videolist2,
    articlelist,
    audiolist,
  },
  data: () => ({
    taglist: [],
    isactitle: 0,
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
    articlist: [],
    a: [],
    b: [],
    c: [],
    ahpage: 1,
  }),

  beforeMount() {
    this.getproblem();
    this.geta();
    this.getb();
    this.getc();
  },
  methods: {
    turnpage(e) {
      this.currentPage = e;
      this.getarticlist();
    },
    clitag(index) {
      this.isactitle = index;
      this.currentPage = 1;
      this.getarticlist();
    },
    getproblem() {
      this.$http.fdlaw.getIndustryIfy().then((res) => {
        this.taglist = res.data;
        this.getarticlist();
      });
    },
    getarticlist() {
      let data = {
        limit: 11,
        cat_id: this.taglist[this.isactitle].id,
        page: this.currentPage,
      };
      this.$http.laws.getarticlist(data).then((res) => {
        this.total = res.data.total;
        this.pageCount = res.data.last_page;
        this.articlist = res.data.data;
      });
    },
    tojump(item) {
      this.$router.push({
        path: "/laws/articimdet",
        query: {
          articinId: item.id,
        },
      });
    },
    geta() {
      this.$http.laws
        .getarticlist({
          limit: 5,
          page: this.ahpage,
          order: "hot",
        })
        .then((res) => {
          this.a = res.data.data;
        });
    },
    getb() {
      this.$http.laws
        .getvideolist({
          limit: 3,
          page: 1,
          order: "hot",
        })
        .then((res) => {
          this.b = res.data.data;
        });
    },
    getc() {
      this.$http.laws
        .getaudiolist({
          limit: 4,
          page: 1,
          order: "hot",
        })
        .then((res) => {
          this.c = res.data.data;
        });
    },
    Inabatch() {
      this.ahpage++;
      this.ahpage>3?this.ahpage=1:'';
      this.geta();
    },
  },
};
</script>

<style lang="scss" scoped>
.atcclcont {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .cont {
    width: 856px;
    padding-bottom: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    .header {
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      .atccl_title {
        height: 57px;
        div {
          cursor: pointer;
          margin-left: 40px;

          font-size: 18px;
          color: #333333;
        }
        .actitle {
          color: #0465ea;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            bottom: -18px;
            left: 50%;
            transform: translateX(-50%);
            width: 58px;
            height: 4px;
            background: #0465ea;
          }
        }
      }
      .atccmo {
        font-size: 16px;
        color: #666666;
        margin-right: 22px;
      }
    }
    .atcclist {
      .atcclitem {
        cursor: pointer;
        padding: 30px 24px;
        border-bottom: 1px solid #eee;
        .problem {
          font-size: 16px;
          color: #333333;
          line-height: 20px;
        }
        .answer {
          margin-top: 10px;
          font-size: 12px;
          color: #666666;
          line-height: 24px;
        }
        .simple {
          margin-top: 14px;
          .name {
            font-size: 14px;
            color: #666666;
            img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .ritext {
            font-size: 12px;
            color: #999999;
            img {
              margin-right: 8px;
            }
            div {
              margin-left: 48px;
            }
            .time {
              width: 12px;
              height: 12px;
            }
            .num {
              width: 15px;
              height: 12px;
            }
          }
        }
        &:hover {
          .problem {
            color: #0465ea;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }

      .bodernone {
        border: none;
      }

      .pagination {
        text-align: center;
        ::v-deep .el-pagination.is-background .btn-next,
        ::v-deep .el-pagination.is-background .btn-prev,
        ::v-deep .el-pagination button,
        ::v-deep .el-pagination span:not([class*="suffix"]),
        ::v-deep .el-pagination.is-background .el-pager li {
          min-width: 36px;
          height: 36px;
          line-height: 36px;
        }
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled).active,
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled):hover {
          color: #ffffff !important;
          background: #0057ff !important;
        }
      }
    }
  }
  .sideadv {
    width: 314px;
    .vrk {
      width: 314px;
      height: 490px;
    }
    .arclerk {
      margin-top: 30px;
      width: 314px;
      height: 586px;
    }
    .vlrecom {
      margin-top: 30px;
      width: 314px;
      height: 640px;
    }
    .aork {
      margin-top: 30px;
      width: 314px;
    }
  }
}
</style>